import React from 'react';
import I18n from '@/modules/i18n';
import { useModalManager } from '@/components/common/Modal';
import SyncActivity from '@/components/shared/SyncActivity';
import { LmsIconKind } from '@/components/shared/Lms/types';
import LmsButton from './LmsButton';

interface ViewSyncActivityProps {
  assignmentId: number;
  lmsKind: LmsIconKind | null;
}

const ViewSyncActivity = ({ assignmentId, lmsKind }: ViewSyncActivityProps) => {
  const modalManager = useModalManager();

  return (
    <>
      <LmsButton
        handleClick={modalManager.open}
        lmsKind={lmsKind}
      >
        <i className="fa fa-lock" /> {I18n.t('view_sync_activity')}
      </LmsButton>
      <SyncActivity
        linkToDashboard
        assignmentId={assignmentId}
        isOpen={modalManager.isOpen}
        onClose={modalManager.close}
      />
    </>
  );
};

export default ViewSyncActivity;
